// eslint-disable-next-line
// @ts-nocheck
import xml from '../core/Xml';

const setPropertyTypeIdNode = (formNode, propertyName) => {
	const itemTypeProperty = window.itemType.selectSingleNode(
		`Relationships/Item[name="${propertyName}"]`
	);
	const propertyTypeNode = formNode.selectSingleNode(
		`Relationships/Item/Relationships/Item[name="${propertyName}"]/propertytype_id`
	);
	if (!itemTypeProperty || !propertyTypeNode) {
		return;
	}

	const propertyTypeId = itemTypeProperty.getAttribute('id');
	xml.setText(propertyTypeNode, propertyTypeId);
};

const prepareFormNode = (formNode, currentItemType) => {
	if (
		currentItemType.startsWith('effs_') &&
		currentItemType.endsWith('_expression')
	) {
		setPropertyTypeIdNode(formNode, 'definition');
		setPropertyTypeIdNode(formNode, 'effs_scope_id');
	}

	return formNode;
};

export default prepareFormNode;
